import React from "react";

const OurServices = () => {
  return (
    <div className="py-10 lg:py-16 xl:py-20 our_services">
      <div className="container px-4 mx-auto">
        <div className="grid grid-cols-12 gap-5 mb-16">
          <div className="col-span-12 text-center lg:col-start-3 lg:col-end-11 xl:col-start-4 xl:col-end-10">
            <h2 className="text-[28px] leading-[39px]">Our Services</h2>
            <p>What We Do For Our Valued Property Management Clients</p>
          </div>
        </div>
        <div className="grid grid-cols-12 gap-3 mb-10">
          <div className="col-span-12 md:col-span-6 text-center bg-[#F7C74F] h-auto py-8 px-12">
            <p className="mb-4 font-bold">
              Property Management and Landlord Communication
            </p>
            <p>
              At Pynguin Property Management, we specialize in bridging the gap
              between landlords and seamless property operations in Florida. Our
              dedicated team ensures clear, consistent communication, keeping
              you informed and your property in Central Florida thriving. We
              handle the details, so you can enjoy peace of mind and profitable
              investments.
            </p>
          </div>
          <div className="col-span-12 md:col-span-6 text-center bg-[#D9D9D9] h-auto py-8 px-12">
            <p className="mb-4 font-bold">Property Marketing</p>
            <p>
              Our comprehensive and competitive marketing strategies are
              designed to attract the right tenants quickly and efficiently. We
              utilize a blend of traditional and digital channels, including
              high-quality photography, local MLS and online listings, and
              targeted online advertising, to showcase the unique aspects of
              your property and its location in Central Florida. Our goal is to
              minimize vacancies and maximize your investment returns through
              strategic and professional property marketing efforts.
            </p>
          </div>
          <div className="col-span-12 md:col-span-6 text-center bg-[#D9D9D9] h-auto py-8 px-12">
            <p className="mb-4 font-bold">Tenant Screening</p>
            <p>
              Our rigorous tenant screening process, tailored for the Central
              Florida market, is designed to secure the best occupants for your
              property. We meticulously evaluate each applicant's background,
              credit history, and rental references, ensuring reliable,
              responsible tenants for your Florida properties. This approach
              minimizes risks and promotes a stable tenancy.
            </p>
          </div>
          <div className="col-span-12 md:col-span-6 text-center bg-[#F7C74F] h-auto py-8 px-12">
            <p className="mb-4 font-bold">Leasing</p>
            <p>
              Focusing on Florida's unique market, our leasing services
              safeguard your interests while ensuring compliance with local
              laws. We manage lease agreements from drafting to execution,
              ensuring all contracts meet Central Florida’s regulations. Our
              approach maximizes property potential and tenant satisfaction.
            </p>
          </div>
          <div className="col-span-12 md:col-span-6 text-center bg-[#F7C74F] h-auto py-8 px-12">
            <p className="mb-4 font-bold">Property Maintenance and Repairs</p>
            <p>
              In Florida, we provide comprehensive maintenance and prompt repair
              services to keep your property in top condition. Regular upkeep
              and swift responses to emergencies in Central Florida are our
              priorities, ensuring tenant safety and preserving your property’s
              value. We guarantee quality work and timely solutions.
            </p>
          </div>
          <div className="col-span-12 md:col-span-6 text-center bg-[#D9D9D9] h-auto py-8 px-12">
            <p className="mb-4 font-bold">Rent Collection</p>
            <p>
              Efficient rent collection is pivotal in Florida's dynamic market.
              Our streamlined process ensures timely rent payments through
              convenient methods for tenants in Central Florida. This approach
              minimizes delays, optimizes your income, and maintains positive
              tenant relations.
            </p>
          </div>
          <div className="col-span-12 md:col-span-6 text-center bg-[#D9D9D9] h-auto py-8 px-12">
            <p className="mb-4 font-bold">Property Inspections</p>
            <p>
              We prioritize the upkeep and value of your property. We carefully
              document conditions at tenant move-in, move-out, and at key points
              in between to ensure your property maintains its allure and value.
              We create meticulous records and detailed descriptions with photos
              of any problems uncovered while inspecting the property – from
              structural integrity to systems performance. Rest assured that
              your investment is protected.
            </p>
          </div>
          <div className="col-span-12 md:col-span-6 text-center bg-[#F7C74F] h-auto py-8 px-12">
            <p className="mb-4 font-bold">Financial Reporting</p>
            <p>
              Our financial reporting offers a transparent view of your Florida
              property's financial health. Regular, detailed reports cover
              income and expenses, offering insights and aiding decisions.
              Clarity and accuracy are our priorities in all financial
              communications for your Central Florida investments.
            </p>
          </div>
          <div className="col-span-12 md:col-span-6 text-center bg-[#F7C74F] h-auto py-8 px-12">
            <p className="mb-4 font-bold">Evictions</p>
            <p>
              In Florida, our eviction process is handled with professionalism
              and strict adherence to legal standards. We take every measure to
              resolve issues amicably in Central Florida; however, if eviction
              is necessary, we act decisively to protect your property and
              minimize disruptions, ensuring a smooth and lawful transition.
            </p>
          </div>
          <div className="col-span-12 md:col-span-6 text-center bg-[#D9D9D9] h-auto py-8 px-12">
            <p className="mb-4 font-bold">Legal Compliance</p>
            <p>
              Navigating the complexities of property law in Florida, we ensure
              your investment complies with regional regulations. From adherence
              to the latest laws for landlords in Central Florida to staying
              abreast of legal changes, our expertise protects you from
              pitfalls. We handle legalities, so you can focus on growing your
              investment.
            </p>
          </div>
        </div>
        <button className="px-6 py-[10px] bg-black rounded-[10px] justify-center items-center gap-1.5 flex text-[#F7C74F] text-base font-medium w-full md:w-fit mx-auto">
        Let’s Get Your Property Rented!
        </button>
      </div>
    </div>
  );
};

export default OurServices;
